import { Controller } from "@hotwired/stimulus"

// Click a PDF first-page thumbnail -> show its large render in a shared Bootstrap modal.
// The modal (#pdf-lightbox) is rendered once per page; each thumbnail carries its own
// src/caption values, so a single controller-per-thumbnail is enough — no targets or
// shared state to wire up.
//
// Usage (see admin/conftool_imports/_pdf_preview partial):
//   <img data-controller="lightbox" data-action="click->lightbox#open"
//        data-lightbox-src-value="<large image url>"
//        data-lightbox-label-value="#149 — Paper title"   (optional submission label)
//        data-lightbox-caption-value="filename.pdf">
//
// When a label is present the modal shows it prominently with the filename as a small
// sub-line; without a label (e.g. an unmatched PDF) the filename is the title on its own.
export default class extends Controller {
  static values = { src: String, caption: String, label: String }

  open() {
    const modalEl = document.getElementById("pdf-lightbox")
    if (!modalEl || !window.bootstrap) return

    const img = modalEl.querySelector("[data-pdf-lightbox-image]")
    const labelEl = modalEl.querySelector("[data-pdf-lightbox-label]")
    const caption = modalEl.querySelector("[data-pdf-lightbox-caption]")
    const title = this.labelValue || this.captionValue || "First page"

    if (img) {
      img.src = this.srcValue
      img.alt = title
    }
    if (labelEl) labelEl.textContent = title
    // Only show the filename sub-line when it isn't already the title.
    if (caption) caption.textContent = this.labelValue ? this.captionValue : ""

    window.bootstrap.Modal.getOrCreateInstance(modalEl).show()
  }
}
